import { render } from "./ExamAiAssistantPatientIntroWelcome.vue?vue&type=template&id=a1b8f9d4&scoped=true"
import script from "./ExamAiAssistantPatientIntroWelcome.vue?vue&type=script&lang=js"
export * from "./ExamAiAssistantPatientIntroWelcome.vue?vue&type=script&lang=js"

import "./ExamAiAssistantPatientIntroWelcome.vue?vue&type=style&index=0&id=a1b8f9d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b8f9d4"]])

export default __exports__